import { useTranslation } from "react-i18next";

import { FilterTreeFormValues, FilterTreeModal } from "./GroupFilterHeader/FilterTreeModal";

type Props = {
    open: boolean;
    initialValues: FilterTreeFormValues;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onSubmit: (values: FilterTreeFormValues) => void;
    description?: string;
};

export const GroupFilterModal = (props: Props) => {
    const { t } = useTranslation(["modals", "common"]);

    return (
        <FilterTreeModal
            open={props.open}
            initialValues={props.initialValues}
            onClose={() => props.setOpen(false)}
            onSubmit={props.onSubmit}
            title={t("modals:groupFilter.title")}
            description={props.description}
            confirmLabel={t("common:button.confirm")}
        />
    );
};
